/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Col, Container, Row} from 'reactstrap';
import { Link } from "react-router-dom";

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';
import PlatformDownloadList from './item-list/platform-download-list';

/**
 * The component (window) to download the app
 */
class DownloadPage extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });

        this.state = {
            subscriptionsData: null,
            navbarMobile: false
        };
        this.props.addTranslation(global);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }
    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        return(
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-red container-padding text-white">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <img src={require('../img/download-main-img.png')} className="img-fluid margin-top-mandatory-50" alt="Landing Math"/>
                                <h1 className="font-now-bold margin-top-mandatory-25">
                                    <Translate id="downloads.downloads" options={{renderInnerHtml: true}}/>
                                </h1>
                                <h2 className="font-now-bold">
                                    <Translate id="downloads.downloads-subtitle" options={{renderInnerHtml: true}}/>
                                    <Link to="/select-plan" className="btn btn-warning">
                                        <Translate id="downloads.here" options={{renderInnerHtml: true}}/>
                                    </Link>.
                                </h2>
                                <hr/>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <PlatformDownloadList/>
                <div className="container-teal container-padding white-text">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.are-you-subscribed" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <Link className="btn btn-imp font-now-bold btn-warning" to="/select-plan">
                                    <Translate id="landing-page.no-subscribe" options={{renderInnerHtml: true}}/>
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(DownloadPage);